// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-edit-component {
  min-height: 100vh;
  margin-bottom: 2rem;
}

.address-subtitle-box {
  margin: 2rem 0 0 0;
}

.address-form-box {
  margin: 0 0 4rem 0;
}

.form-field {
  width: 100%;
}

.back-button {
  margin: 0 0 0 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/customer/components/customer-edit/customer-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA,YAAA;AACA;EACE,0BAAA;AACF","sourcesContent":[".address-edit-component {\r\n    min-height: 100vh;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.address-subtitle-box {\r\n    margin: 2rem 0 0 0;\r\n}\r\n\r\n.address-form-box {\r\n    margin: 0 0 4rem 0;\r\n}\r\n\r\n.form-field {\r\n    width: 100%;\r\n}\r\n\r\n.back-button {\r\n    margin: 0 0 0 0;\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n  -moz-appearance: textfield;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
